/**
 * ASI marketing surfaces — navy backdrop + sparse metal-gold accents.
 *
 * Theme choice: dark deliberately (B2B splash; matches Champion Remotion slates).
 * Gold is the multi-stop metal gradient from @asi/design-tokens (same as FusionMSI /
 * VoxPont APP_GOLD_METAL*), used sparingly — brand wordmark / one hero signal —
 * not as a page-wide flat accent color.
 */
import { darkTheme } from '@asi/design-tokens';

const { navyDeep, navy, secondaryDark, goldMetal, goldMetalText } =
  darkTheme.colors;

/** Dark-mode marketing page backdrop */
export const ASI_MARKETING_GRADIENT_DARK = `linear-gradient(155deg, ${navyDeep} 0%, ${navy} 55%, ${secondaryDark} 100%)`;

/** Fill gradient — thin rules, small brand marks */
export const ASI_GOLD_METAL = goldMetal;

/** Text fill — brand wordmark / single hero signal (clip to text) */
export const ASI_GOLD_METAL_TEXT = goldMetalText;

/** sx helper for metal-gradient clipped text */
export const asiGoldMetalTextSx = {
  background: ASI_GOLD_METAL_TEXT,
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  backgroundClip: 'text',
};

/** sx helper for primary CTAs — metal fill, not flat palette.primary */
export const asiGoldMetalButtonSx = {
  background: ASI_GOLD_METAL,
  color: 'primary.contrastText',
  fontWeight: 700,
  '&:hover': {
    background: ASI_GOLD_METAL,
    opacity: 0.92,
  },
};

export { darkTheme as asiMarketingBrandTheme };
